module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/resonio/confirm_de-52c09289a5d1e52d89ef945c5c8e428c.gif";